import React from "react";
import css from "./SideHeader.module.css";
import { sideHeaderElements } from "../../data/sideHeader";
import { FiMail } from "react-icons/fi";
import { contact } from "../../data/contact";
import profilePhoto from "../../assets/avatar1-professional.webp";

const SideHeader = ({ activeSection }) => {
  const navItems = sideHeaderElements[1].list;
  const socialLinks = sideHeaderElements[2].socialLinks;

  return (
    <aside className={css.sidebar} aria-label="Sidebar navigation">
      <div className={css.profile}>
        <img
          src={profilePhoto}
          alt="Abdellah Khedid"
          className={css.profilePhoto}
        />
        <h1 className={css.name}>{sideHeaderElements[0].name}</h1>
        <p className={css.role}><span className={css.statusDot} /> Web · Mobile · AI</p>
      </div>

      {/* Navigation */}
      <nav className={css.nav}>
        <ul className={css.navList}>
          {navItems.map((item, i) => (
            <li key={i} className={css.navItem}>
              <a
                href={`#${item.link}`}
                className={`${css.navLink} ${
                  activeSection === item.link ? css.navLinkActive : ""
                }`}
              >
                <span className={css.navText}>{item.text}</span>
                <span className={css.navIndicator} />
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {/* CTA */}
      <div className={css.ctaWrap}>
        <a
          href={`mailto:${contact.email}`}
          className={css.ctaBtn}
        >
          <FiMail />
          <span>Discuss a Role</span>
        </a>
      </div>

      {/* Social */}
      <div className={css.social}>
        <p className={css.socialLabel}>Connect</p>
        <div className={css.socialRow}>
          {socialLinks.map((link, i) => (
            <a
              key={i}
              href={link.link}
              className={css.socialLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Social link ${i + 1}`}
            >
              {link.icon}
            </a>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className={css.footer}>
        <p className={css.copyright}>
          &copy; {new Date().getFullYear()} KHEDID
        </p>
      </div>
    </aside>
  );
};

export default SideHeader;
